import { BaseDataTransferObject } from '../../../shared/models/base-data-transfer-object';

export enum RequisitionStatus {
    None = 0,
    Pending = 1,
    Canceled = 2,
    Done = 4,
    All = 0x00000007 // Done | Canceled | Pending,
}

export class RequisitionSearch extends BaseDataTransferObject {
    public code?: string;
    public collectionDate?: Date;
    public patientLastName?: string;
    public bed?: string;
    public unit?: string;
    public room?: string;
    public patientFirstName?: string;
    public patientBirthDate?: Date;
    public clientName?: string;
    public patientId?: number;
    public clientId?: number;
    public tests?: string[];
    public hasSignature?: boolean;
    public status?: RequisitionStatus;
}
